import React, { useContext } from 'react'
import {
    Box,
    Stack,
    Typography
} from '@mui/material'

import { ThemeContext } from '../../context/theme/context.js'
import useCursorHandlers from '../../hooks/cursor_handlers.js'

import data from '../../data/portfolio.json'

const Home = () => {
    const { state } = useContext(ThemeContext)
    const cursorHandler = useCursorHandlers()

    return <Box
        width="100%"
        display={"flex"}
        justifyContent="center"
        alignItems="center"
        minHeight={"100vh"}>
        <Stack
            width="50%"
            direction={{ xs: 'column' }}
            spacing={{ xs: 1, sm: 2, md: 4 }}
            justifyContent="center"
            alignItems="center"
            {...cursorHandler}>
            <Typography
                variant="h2"
                gutterBottom
                fontFamily='"Nunito Sans", sans-serif, Arial, Helvetica'
                sx={{
                    color: state.color.primary,
                    fontWeight: 700,
                    fontSize: { xs: 18, md: 24 },
                    letterSpacing: '0.4em',
                    lineHeight: "150%",
                    textTransform: 'uppercase',
                }}>
                {data.name}
            </Typography>
            <Typography
                variant="h1"
                gutterBottom
                fontFamily='"Nunito Sans", sans-serif, Arial, Helvetica'
                textAlign="center"
                sx={{
                    color: state.color.secondary,
                    fontWeight: 900,
                    fontSize: { xs: 36, sm: 52, md: 64, lg: 72 },
                    letterSpacing: '0.05em',
                    textTransform: 'uppercase',
                }}
            >
                {data.title}
            </Typography>
        </Stack>
    </Box>
}

export default Home
